import { api } from "..";

import { RiskScope } from "@/types/ApiResponses/Risk";

export const getRiskScope = async (props: {
  signal?: AbortSignal;
}): Promise<RiskScope> => {
  const res = await api.client.get("/risk/scope", { signal: props.signal });
  return res.data;
};
